import React from "react";
import ContactHero from "../sections/ContactHero";
import Map from "../sections/Map";
import ContactForm from "../sections/ContactForm";
import ContactSection from "../sections/ContactSection";

const Contact = () => {
  return (
    <div>
      <ContactHero />
      <Map />
      <ContactForm />
      <ContactSection />
    </div>
  );
};

export default Contact;
